import DeleteIcon from "@mui/icons-material/DeleteRounded";
import { Button } from "@mui/material";

import { AppointmentResponse } from "@/api";
import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useTranslation } from "@/translations";

import { AppointmentFormFields } from "../shared/AppointmentFormFields";
import { useAppointmentEdit } from "./hooks/useAppointmentEdit";

interface Props {
  appointment: AppointmentResponse;
  onClose: () => void;
}

export function AppointmentEditDialog({ appointment, onClose }: Props) {
  const { t } = useTranslation();
  const { formik, fieldOptions, assignedClient, handleIsAllDayChange, handleDeleteClick, isDeleting } =
    useAppointmentEdit(appointment, onClose);

  return (
    <FormDialog
      title={t("calendar.appointmentEdit.title")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("calendar.appointmentEdit.submitButton")}
      extraAction={{
        left: (
          <Button
            variant="outlined"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={handleDeleteClick}
            disabled={isDeleting}
          >
            {t("calendar.appointmentEdit.deleteButton")}
          </Button>
        ),
      }}
    >
      <AppointmentFormFields
        formik={formik}
        {...fieldOptions}
        onIsAllDayChange={handleIsAllDayChange}
        assignedClient={assignedClient}
      />
    </FormDialog>
  );
}
